// extracted by mini-css-extract-plugin
export default {"item":"Cancel_item__Wckmj","item-wp":"Cancel_item-wp__sUMum"};